import { createGlobalStyle } from "styled-components";

export const Colors = createGlobalStyle`
  :root {
  --color-primary: #FFD446;
  --color-green: #C2FFCE;
  --color-blue: #8ABEF9;
  --color-white: #FFFFFF;
  --color-black: #000000;
  --color-grey: #E0E0E0;
}
`;
